import { useQuery } from '@tanstack/react-query'

import { sidebarApi } from '@/api/endpoints/sidebar'
import type { SidebarSectionDTO } from '@/api/endpoints/sidebar'
import { useAuthStore } from '@/stores/authStore'

/**
 * Fetch the dynamic, company-wise sidebar for the current user.
 *
 * Server-filtered by company features + user permissions, so the component
 * just renders what it gets. Cached 5 minutes; only runs when authenticated.
 */
export function useSidebar() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  return useQuery<SidebarSectionDTO[]>({
    queryKey: ['sidebar'],
    queryFn: () => sidebarApi.getSidebar(),
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000,
  })
}
